import { DraggableKeys, ModalKeys } from "../../main";

export type ActiveToolsState = {
  activeItems: string[];
  hasDisclaimerBeenShown: boolean;
  alertMessage: string;
};

export type ActiveToolsActions = {
  toggleActiveItem: (item: string) => void;
  isActive: (activeItem: string) => boolean;
  activateTool: (key: string) => void;
  deactivateTool: (key: string) => void;
  setActiveTool: (key: string, val: boolean) => void;
  setHasDisclaimerBeenShown: (val: boolean) => void;
  setAlertMessage: (message: string) => void;
};

export const createActiveToolsSlice = (
  set,
  get
): ActiveToolsState & ActiveToolsActions => ({
  activeItems: [],
  isActive: (item) => get().activeItems.includes(item),
  toggleActiveItem: (activeItem) => {
    console.log(activeItem, get().activeItems);
    const activeItems = [...get().activeItems];
    const index = activeItems.indexOf(activeItem);
    if (index === -1) {
      activeItems.push(activeItem);
    } else {
      activeItems.splice(index, 1);
    }
    set({ activeItems });
  },
  setActiveTool: (key, val) => {
    const activeItems = [...get().activeItems];
    console.log("setActiveTool", key, val, activeItems);

    if (activeItems.includes(key) === val) return;

    if (val) {
      activeItems.push(key);
    } else {
      const index = activeItems.indexOf(key);
      if (index !== -1) {
        activeItems.splice(index, 1);
      }
    }
    set({ activeItems });
  },
  activateTool: (key) => {
    if (key === ModalKeys.DISCLAIMER) {
      if (get().hasDisclaimerBeenShown) return;
      get().setHasDisclaimerBeenShown(true);
    }

    get().setActiveTool(key, true);
  },
  deactivateTool: (key) => {
    get().setActiveTool(key, false);
  },
  hasDisclaimerBeenShown: false,
  setHasDisclaimerBeenShown: (val) => {
    set({ hasDisclaimerBeenShown: val });
  },
  alertMessage: "",
  setAlertMessage: (message) => {
    set({ alertMessage: message });
  },
});
